import React from 'react'
import { DetailsRow } from '../DetailsRow'
import { DetailsColumn } from '../DetailsColumn'
import { FieldsRow } from '../FieldsRow'
import { ReadOnlyTextField } from 'components/Shared/ReadOnlyTextField'
import { CountryReadOnlyField } from 'components/Shared/CountryReadOnlyField/CountryReadOnlyField'
import Sections from 'components/Order/sections'

export function CustomsControlDetails ({ customsControl, diffValues }) {

  return (
    <DetailsRow section={Sections.CustomsControl}>
      <DetailsColumn>
        <ReadOnlyTextField value={customsControl.customsAgencyName}
                           label="order.details.customsControl.fields.customsAgency"
                           previousValue={diffValues && { value: diffValues.customsAgencyName }}
        />
        <ReadOnlyTextField value={customsControl.address.address}
                           label="order.details.customsControl.fields.address"
                           previousValue={diffValues && { value: diffValues.address.address }}
        />
        <ReadOnlyTextField value={customsControl.address.city}
                           label="order.details.customsControl.fields.city"
                           previousValue={diffValues && { value: diffValues.address.city }}
        />
        <FieldsRow>
          <CountryReadOnlyField
            value={customsControl.address.countryCode}
            label="order.details.customsControl.fields.country"
            previousValue={diffValues && { value: diffValues.address.countryCode }}
          />
          <ReadOnlyTextField value={customsControl.address.zipCode}
                             label="order.details.customsControl.fields.zipCode"
                             previousValue={diffValues && { value: diffValues.address.zipCode }}
          />
        </FieldsRow>
      </DetailsColumn>
      <DetailsColumn>
        <ReadOnlyTextField value={customsControl.contactPersonName}
                           label="order.details.customsControl.fields.contactPerson"
                           previousValue={diffValues && { value: diffValues.contactPersonName }}
        />
        <ReadOnlyTextField value={customsControl.additionalInfo}
                           label="order.details.customsControl.fields.additionalInfo"
                           previousValue={diffValues && { value: diffValues.additionalInfo }}
        />
      </DetailsColumn>
    </DetailsRow>
  )
}
